import ResponsibilitiesTab from './ResponsibilitiesTab';
export default ResponsibilitiesTab;